export default "/images/ic-view-bg-white.svg?8155731dd47d4a983d8c1ed6724ea06c";